function normalizeBooleanEnv(value: string | undefined) {
  if (!value) return true;
  const normalized = value.trim().toLowerCase();
  if (["false", "0", "off"].includes(normalized)) return false;
  return true;
}

export function getEmailPasswordAuthEnabled(
  rawValue: string | undefined = process.env.NEXT_PUBLIC_EMAIL_PASSWORD_AUTH_ENABLED,
) {
  return normalizeBooleanEnv(rawValue);
}

export const EmailPasswordAuth = {
  get Enabled() {
    return getEmailPasswordAuthEnabled();
  },
};

export function getInstantAssistantEnabled(
  rawValue: string | undefined = process.env.NEXT_PUBLIC_INSTANT_ASSISTANT_ENABLED,
) {
  return normalizeBooleanEnv(rawValue);
}

export const InstantAssistantFeature = {
  get Enabled() {
    return getInstantAssistantEnabled();
  },
};

export function getInstantAssistantVoiceEnabled(
  rawValue: string | undefined = process.env.NEXT_PUBLIC_INSTANT_ASSISTANT_VOICE_ENABLED ?? "false",
) {
  return normalizeBooleanEnv(rawValue);
}

export const InstantAssistantVoiceFeature = {
  get Enabled() {
    return getInstantAssistantVoiceEnabled();
  },
};

export const featureFlags = {
  emailPasswordAuthEnabled: EmailPasswordAuth.Enabled,
  instantAssistantEnabled: InstantAssistantFeature.Enabled,
  instantAssistantVoiceEnabled: InstantAssistantVoiceFeature.Enabled,
};
